<template>
  <div>
    <Headersys />
    <div class="content">
      <div v-if="step == 1">
        <parser ref="parser" :key="new Date().getTime()" :form-conf="detailForm" @submit="submitForm" />
        <div style="width: 100%;height: 10vh;"></div>
      </div>
      <div v-else>
        <div class="section-box">
          <div class="realy-content">
            <div class="section-code-box">
              <div>
                <canvas id="qrCode"></canvas>
                <div class="qr-tips">手机扫描二维码</div>
                <div class="qr-tips">上传材料</div>
              </div>
            </div>
            <div class="section-content-box">
              <div class="side-box">
                <div class="side-title">
                  受理条件
                </div>
                <div class="side-item">
                  <div v-for="(item, idx) in conditionList" :key="idx">{{ idx + 1 }}.{{ item.NAME }}</div>
                </div>
              </div>
              <div class="side-box">
                <div class="side-title">
                  申请材料
                </div>
                <div class="cl-box" v-for="(item, idx) in materialList" :key="idx">
                  <div class="cl-title-file-box">
                    {{ idx + 1 }}.{{ item.NAME }}<span class="red must" v-if="item.MUST == '1'">(必要)</span><span v-else
                      class="must">(非必要)</span>
                    <div class="file-card" v-for="(file, index) in item.fileList" :key="index">
                      {{ file.fileName }}
                      <div class="btn-all-box">
                        <div class="prev-btn">预览
                          <el-image style="width: 17rem; height: 12rem;position: absolute;top: 0;left: 0;opacity: 0;"
                            :src="file.url" :preview-src-list="file.url.split(',')">
                          </el-image>
                        </div>
                        <div class="delt-btn" @click="deltFile(idx, index)">删除</div>
                      </div>
                    </div>
                    <div class="file-card" v-if="item.shiti == '1'">
                      提交实体材料
                      <div class="btn-all-box">
                        <div class="delt-btn" @click="deltShitiFile(idx)">删除</div>
                      </div>
                    </div>
                  </div>
                  <div class="cl-add-btn" @click="addFiles(item, idx)">
                    添加材料
                  </div>
                </div>
              </div>
              <div style="height: 10rem;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <submitBtn :step="step" @BackEvt="BackEvt" @toSubmit="toSubmit" @nextEvt="nextEvt" />
    <!-- <canvas id="sbCode"></canvas> -->
    <div v-if="fileGPY" class="gpy-mask">
      <div class="file-upload-box">
        <div class="file-title-box">{{ uploadTitle }} <span class="red" v-if="uploadMust == '1'">(必要*)</span></div>
        <div class="file-type-box">
          <div class="type-box">
            <div class="type-btn">拍照上传</div>
          </div>
          <div class="shiti-btn" @click="addShitiFile">提交实体材料</div>
        </div>
        <div class="gpy-content-box">
          <div class="gpy-file-list">
            <img class="gyp-img" :src="url" alt="" v-for="(url, idx) in gpyimgList" :key="idx">
          </div>
          <div class="gpy-file-content">
            <!-- <img class="gpy-images" src="http://127.0.0.1:38088/video=stream&camidx=0?1" alt=""> -->
            <img class="gpy-images" :src="GPYbaseImg" alt="">
            <el-button class="btn-gpy-box" type="primary" @click="getGpyImage">扫描上传</el-button>
          </div>
        </div>
        <div class="submit-btn-box">
          <div class="submit-gpy-btn" @click="submitGpyFile">
            确认
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Parser from '@/components/parser/Parser'
import { decodeFields } from "@/utils/formGenerator";
import QRCode from "qrcode";
import { v4 as uuidv4 } from "uuid";
import { pinyin } from 'pinyin-pro';
// import idcardUrl from "@/assets/js/idcard.js";
import lodop from "@/assets/js/doPrint.js"

export default {
  name: '',
  components: {
    Parser
  },
  data() {
    return {
      //
      waitTime: 290,
      watiTimer: null,
      // 流程表单详情
      detailForm: {
        fields: []
      },
      masterId: "", //事项id
      masterDeptId: '', //部门id
      processDefinitionId: "", //流程表单id
      step: 1,//当前步骤 1表单 2材料
      details: {},//详情
      materialList: [],//申请材料
      conditionList: [],//受理条件
      consultInfo: {},//咨询投诉
      code: '',
      variables: {},//表单变量
      uuid: "",
      fileGPY: false,//高拍仪文件上传
      uploadTitle: "",//文件上传展示展示标题
      currentIdx: '',//当前选中下标
      uploadMust: '',//是否必传
      gpyimgList: [],//高拍仪照片列表
      previewUrl: "https://zw.zwfwpt.cn/prod-api",
      name: '',
      phone: '',
      idCard: "",
      fmac: "",
      listTimer: null,
      GPYbaseImg: "",//高拍仪视频
      farmTime: null,//高拍仪获取帧定时器
    };
  },
  created() {
    var options = this.$route.query
    this.masterId = options.masterId
    this.masterDeptId = options.masterDeptId
    this.init()
    this.code = this.$route.query.code
    // this.getShenCL()
    this.getDetails()
  },

  mounted() {
    // this.timeDown()
  },
  beforeDestroy() {
    // console.log('清除定时器');
    clearTimeout(this.watiTimer);
    clearTimeout(this.listTimer);
  },
  methods: {
    // 打印申报流水
    printSBLS(data) {
      // var _this = this
      // 创建一个二维码
      QRCode.toDataURL(`https://l.zwfwpt.cn/#/userCheck?flowId=${data.lsh}`, function (err, url) {
        if (err) console.error(err);
        // 此时的url就是二维码图片的base64编码的DataURL
        // _this.printZB(data, url);
        lodop.sbxbPrint(data, url)
      });
    },
    //获取事项详情
    getDetails() {
      this.$rqt.division_sendUr2({
        url: 'getItemInfoByItemCode',
        params: {
          // regionCode: '370705000000',
          itemCode: this.$route.query.code,
          infoType: "info"
        }
      }).then(res => {
        this.details = JSON.parse(res.data).ItemInfo[0]
        setTimeout(() => {
          this.$fun.getMAC(mac => {
            this.fmac = mac;
            // var userInfo = JSON.parse(localStorage.getItem('USERINFO'))
            var userInfo = this.$store.state.suerInfo
            this.name = userInfo.name;
            this.phone = userInfo.tel;
            this.idCard = userInfo.cerno;
            this.$rqt.print_saveClickRecord({
              fname: this.name,
              fcerno: this.idCard,
              phone: this.phone,
              fmac: this.fmac,
              fitemid: this.code,
              fitem: '事项申报 ' + this.details.NAME,
            });
          })
        }, 1000);
      })
    },
    // 提交实体材料
    addShitiFile() {
      this.materialList[this.currentIdx].shiti = '1'
      this.saveList()
      this.fileGPY = false
    },
    // 删除实体材料
    deltShitiFile(idx) {
      this.materialList[idx].shiti = '0'
      this.saveList()
    },
    // 添加材料
    addFiles(item, idx) {
      // console.log(idx, item);
      this.currentIdx = idx
      this.uploadTitle = item.NAME
      this.uploadMust = item.MUST
      this.fileGPY = true
      this.getGPY()
    },
    // 获取设备信息
    getGPY() {
      this.$rqt.GPY_GetAllDisplayInfo().then(res => {
        // console.log(res);
        this.openGPY()
      })
    },
    // 打开视频
    openGPY() {
      var data = {
        dev_idx: "0", // 摄像头 id
        res_id: "0" // 分辨率索引
      }
      this.$rqt.GPY_StartPreview(data).then(res => {
        if (res.returnCode == "0" || res.returnCode == "2") {
          this.farmTime = setInterval(() => {
            this.getFrame()
          }, 300);
        }
      })
    },
    // 获取针
    getFrame() {
      this.$rqt.GPY_getFrame().then(res => {
        if (res.returnCode == '0') {
          this.GPYbaseImg = "data:image/jpg;base64," + res.data.img
        }
      })
    },
    // 删除材料
    deltFile(idx, index) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      }).then(() => {
        this.materialList[idx].fileList.splice(index, 1)
        this.saveList()
      })
    },
    // 保存文件列表
    saveList() {
      this.$rqt.sxsb_system_profile_saveRecord({
        key: this.uuid,
        value: this.materialList
      })
    },
    // 获取文件列表
    getList() {
      this.$rqt.sxsb_system_profile_getRecord({
        key: this.uuid
        // key: '10086',
      }).then(res => {
        if (res.data) {
          this.materialList = res.data
        }
        this.listTimer = setTimeout(() => {
          this.getList()
        }, 10000);
      })
    },
    // 汉字转拼音
    convertToPinyin(text) {
      return "myFile" + pinyin(text, { toneType: 'none' }).replace(/ /g, "").replace(/,/g, "").replace(/《/g, "").replace(/》/g, "").replace(/、/g, "")
    },
    // 获取流程id
    init() {
      this.$rqt.sxsb_selectByDataGetFlow({
        masterId: this.masterId,
        masterDeptId: this.masterDeptId,
        regorg: '370705',
      }).then(res => {
        // console.log('表单id', res.data.processDefinitionId);
        this.processDefinitionId = res.data.processDefinitionId
        this.getFormJson(this.processDefinitionId)
      })
    },
    // 使用流程id获取表单信息
    getFormJson(id) {
      this.$rqt.sxsb_process_definition_detail({ id }).then(res => {
        // console.log('表单信息', res);
        var row = res.data
        this.detailForm = {
          ...JSON.parse(row.formConf),
          fields: decodeFields(row.formFields),
          formBtns: false, // 按钮隐藏
        }
      })
    },
    /** 提交按钮 */
    submitForm(params) {
      if (!params) {
        return;
      }
      this.step = 2
      this.variables = params.values;
      this.code = this.$route.query.code
      this.getSLTJ()
      this.getShenCL()
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--
        } else {
          this.waitTime = 290
          clearInterval(this.watiTimer)
          this.$router.replace('/')
        }
      }, 1000);
    },
    // 申请材料
    getShenCL() {
      this.uuid = uuidv4().replaceAll("-", "");
      // this.uuid = '10086'
      this.$rqt.division_sendUr2({
        url: 'getItemInfoByItemCode',
        params: {
          itemCode: this.code,
          infoType: "material"
        }
      }).then(res => {
        // console.log('申请材料', JSON.parse(res.data));
        this.materialList = []
        var arr = JSON.parse(res.data).ItemInfo
        arr.forEach(el => {
          this.materialList.push({
            NAME: el.NAME,
            MUST: el.MUST,
            fileList: [],
            shiti: '0'
          })
        });
        // console.log('申请材料', this.materialList);
        // this.getList()
        this.useqrcode()
        // 保存申请材料记录
        this.saveList()
        // 获取文件列表
        setTimeout(() => {
          this.getList()
        }, 10000);
      })
    },
    // 受理条件
    getSLTJ() {
      this.$rqt.division_sendUr2({
        url: 'getItemInfoByItemCode',
        params: {
          itemCode: this.code,
          infoType: "condition"
        }
      }).then(res => {
        // console.log('受理条件',JSON.parse(res.data));
        this.conditionList = JSON.parse(res.data).ItemInfo
      })
    },
    useqrcode() {
      var canvas = document.getElementById("qrCode");
      // 调用函数去生成二维码，参数依次为：二维码的容器、要生成的内容、回调函数   http://192.168.1.104:8080
      QRCode.toCanvas(
        canvas,
        // `http://192.168.1.104:8080/#/sxsbFile?id=${this.uuid}`,
        `https://l.zwfwpt.cn/#/sxsbFile?id=${this.uuid}`,
        function (error) {
          if (error) {
            console.error(error);
          }
        }
      );
    },
    BackEvt() {
      // this.variables
      var keys = Object.keys(this.variables);
      keys.forEach(item => {
        this.detailForm.fields.filter(mod => {
          return mod.__vModel__ == item
        }).forEach(item => {
          item.__config__.defaultValue = this.variables[item.__vModel__]
        });
      })
      this.step = 1
    },
    nextEvt() {
      // console.log('点击下一步', this.$refs.parser.submitForm());
      this.$refs.parser.submitForm()
    },
    toSubmit() {
      this.$rqt.sxsb_system_profile_getRecord({
        key: this.uuid,
        // key: "10086",
      }).then(res => {
        if (res.data) {
          this.materialList = res.data
          // console.log("提交", res.data);
          var arr = res.data
          var notUploaded = {
            NAME: ""
          }
          var obj2 = {}
          var variables = {}
          arr.forEach(el => {
            if (el.MUST == '1' && el.fileList.length == 0 && el.shiti == '0') {
              notUploaded = el
            } else {
              // obj2[this.convertToPinyin(el.NAME)] = el.fileList
              var arr = []
              el.fileList.forEach(item => {
                arr.push(item.url)
              })
              obj2[el.NAME] = arr
            }
          })
          // console.log(obj2);
          if (notUploaded.NAME) {
            this.$alert(`请上传${notUploaded.NAME}`, '提示', {
              confirmButtonText: '确定',
              lockScroll: false
            });
            return
          }
          variables = Object.assign(this.variables, obj2)
          this.$rqt.sxsb_process_definition_create({
            processDefinitionId: this.processDefinitionId,
            variables
          }).then(response => {
            if (response.code == 200) {
              if (this.phone) {
                this.$rqt.common_sendSms('13176708822', `${this.name}(${this.idCard})已申报${this.details.NAME}，联系电话：${this.phone}`)
              } else {
                this.$rqt.common_sendSms('13176708822', `${this.name}(${this.idCard})已申报${this.details.NAME}`)
              }
              var info = {
                name: this.name,
                lsh: response.msg,
                title: this.details.NAME,
                pswd: this.generateFiveDigitNumber()
              }
              this.printSBLS(info)
              this.saveBindFlowMaster(response.msg, variables)
              this.$alert('申报成功', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.go(-1);
                }
              });
            } else {
              this.$alert(res.msg, '提示', {
                confirmButtonText: '确定',
              });
            }
            // 关闭当前窗口
          }).catch(() => {
            conf.disabled = false; // 表单开启
            conf.formBtns = true; // 按钮展示
          })
        }
      })
    },
    generateFiveDigitNumber() {
      // 生成一个0到99999之间的随机整数
      const randomNumber = Math.floor(Math.random() * 100000);
      // 将随机数转换成五位数字符串，不足五位数前面补零
      return String(randomNumber).padStart(6, '0');
    },
    saveBindFlowMaster(flowId, content) {
      this.$rqt.sxsb_master_saveBindFlowMaster({
        flowId,
        content: JSON.stringify(content),
        name: this.details.NAME,
        cardId: this.idCard,
        userName: this.name
      })
    },
    // 高拍仪拍照
    getGpyImage() {
      this.$rqt.GPY_getFrame().then(res => {
        if (res.returnCode == '0') {
          this.gpyimgList.push("data:image/jpg;base64," + res.data.img)
        }
      })
      // let data = {
      //   "filepath": "base64",
      //   "rotate": "0",
      //   "cutpage": "0",
      //   "camidx": "0",
      //   "ColorMode": "0",
      //   "quality": "1"
      // }
      // this.$rqt.video_grabimage(JSON.stringify(data)).then(res => {
      //   this.gpyimgList.push("data:image/jpg;base64," + res.photoBase64)
      // })
    },
    // 提交高拍仪材料
    submitGpyFile() {
      this.$rqt.GPY_StopPreview({
        dev_idx: "0"
      })
      clearInterval(this.farmTime)
      var arr = []
      this.gpyimgList.forEach(url => {
        arr.push(this.$fun.base64ToFile(url, '材料照片'))
      })
      const formData = new FormData();
      arr.forEach(el => {
        formData.append("files", el);
      });
      this.$rqt.sxsb_system_profile_uploadFileBatch(formData).then(res => {
        res.data.forEach(el => {
          this.materialList[this.currentIdx].fileList.push({
            url: this.previewUrl + el.img,
            fileName: el.name
          })
        })
        this.saveList()
        this.fileGPY = false
        this.gpyimgList = []
      })
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.section-box {
  // display: flex;
  // align-items: center;
  // background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2rem;
  position: relative;

  .realy-content {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 2rem;
  }

  .section-code-box {
    width: 20%;
    height: calc(100vh - 60rem);
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid rgba($color: #000000, $alpha: .1);

    .qr-tips {
      text-align: center;
      font-weight: bold;
      margin-bottom: 3rem;
      font-size: 5rem;
    }
  }

  .section-content-box {
    width: 80%;
    height: calc(100vh - 93rem);
    overflow-y: scroll;

    .side-box {
      width: 95%;
      margin: auto;
      padding: 4rem 0 5rem;
      border-bottom: 2px solid #DFDCDF;

      .side-title {
        font-size: 5rem;
        font-weight: bold;
        color: #55A5FF;
        margin-bottom: 3rem;
      }

      .side-item {
        font-size: 4rem;
      }

      .cl-box {
        font-size: 6rem;
        display: flex;
        justify-content: space-between;
        // align-items: center;
        border-bottom: 1px solid #DFDCDF;
        margin: 10px 0;
        padding-bottom: 10px;

        .cl-title-file-box {
          width: 75%;

          .file-card {
            background-color: #E7F4FF;
            padding: 3px;
            display: flex;
            justify-content: space-between;
            margin: 5px 0;

            .btn-all-box {
              display: flex;
            }

            .prev-btn {
              position: relative;
              width: fit-content;
              height: fit-content;
              color: #ffffff;
              background-color: #42C019;
              padding: 5px 10px;
              border-radius: 5px;
              border: 1px solid #DFDCDF;
              margin-right: 20px;
            }

            .delt-btn {
              width: fit-content;
              height: fit-content;
              color: #ffffff;
              background-color: #FF9254;
              padding: 5px 10px;
              border-radius: 5px;
              border: 1px solid #DFDCDF;
            }
          }
        }

        .cl-add-btn {
          width: fit-content;
          height: fit-content;
          color: #55A5FF;
          background-color: #EEF8FF;
          padding: 10px 20px;
          border-radius: 10px;
          border: 1px solid #DFDCDF;
        }

        .cl-add-btn:active {
          background-color: #f2f3f4;
        }
      }
    }
  }

  .section-content-box::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
}

#qrCode {
  width: 30rem !important;
  height: 30rem !important;
  display: block;
  margin: 0 auto 5rem;
}

#sbCode {
  width: 30rem !important;
  height: 30rem !important;
  position: fixed;
  top: -9999px;
  left: -9999px;
}

.must {
  margin-left: 3rem;
}

.red {
  color: #ff0000;
}

.gpy-mask {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;

  .file-upload-box {
    width: 300rem;
    height: 85vh;
    background-color: #fff;
    border: 1px solid #DFDCDF;
    border-radius: 20px;

    .file-title-box {
      background-color: #52A7FF;
      border-radius: 20px 20px 0 0;
      height: 17rem;
      line-height: 17rem;
      font-size: 6rem;
      color: #ffffff;
      text-indent: 5rem;
      border-bottom: 1px solid #DFDCDF;
    }

    .file-type-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 5rem;
      border-bottom: 1px solid #DFDCDF;

      .type-box {
        display: flex;
        align-items: center;

        .type-btn {
          padding: 10px 20px;
          color: #ffffff;
          background-color: #51A8FF;
        }
      }

      .shiti-btn {
        font-size: 6rem;
        line-height: 6rem;
        color: #F9A028;
        border: 1px solid #F9A028;
        padding: 10px 10px;
        border-radius: 5px;
        margin-right: 10px;
      }
    }

    .gpy-content-box {
      width: 100%;
      height: calc(85vh - 42rem - 22px);
      display: flex;
      border-bottom: 1px solid #DFDCDF;

      .gpy-file-list {
        width: 20%;
        background-color: #1A181B;
        height: calc(85vh - 42rem - 22px);
        overflow-y: scroll;

        .gyp-img {
          width: 100%;
          display: block;
          margin-bottom: 5px;
        }
      }

      .gpy-file-list::-webkit-scrollbar {
        width: 0px;
        height: 0px;
      }

      .gpy-file-content {
        width: 80%;
        height: calc(85vh - 42rem - 22px);
        position: relative;

        .gpy-images {
          width: 100%;
          height: calc(85vh - 42rem - 22px);
        }

        .btn-gpy-box {
          position: absolute;
          left: calc(50% - 20rem);
          bottom: 5rem;
        }
      }
    }

    .submit-btn-box {
      width: 100%;
      height: 20rem;
      border-radius: 0 0 20px 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      .submit-gpy-btn {
        font-size: 7rem;
        background-color: #52A7FF;
        width: fit-content;
        text-align: center;
        padding: 10px 30px;
        color: #ffffff;
        border-radius: 10px;
      }
    }
  }
}

.red {
  color: #ff0000;
}
</style>